import NotFound from './NotFound';
import { all } from '../data/all';

function AllData() {

    let countryData = [];
    all.forEach(country => {
        countryData.push(JSON.stringify(country));
    });
    countryData.sort();

    if (countryData.length === 0) {
        return (
            <NotFound />
        )
    } else {
        return (
            <code>
                { countryData }
            </code>
        )
    }
}

export default AllData;